import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';
import { Campaign } from '@/client/types/whatsapp/broadcast-campaigns';

type ApiResponse = {
  data: {
  cached: boolean;
  exec_time: number;
  trace_id: string;
  status: number;
  campaigns: Campaign[];
  total_pages: number;
  total_broadcasts: number;
  page: number;
  per_page: number;
}};

type QueryResponse = ApiResponse;

export const createListBroadcastsKey = (additional: any[] = []) => [
  'list-broadcasts',
  ...additional,
];

export const useListBroadcastsQuery = (additionalProps = {}) => { 
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Broadcasts',
    endpoint: `/api/admin/whatsapp/broadcasts`,
  });

  return useQuery({
    queryKey: createListBroadcastsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};